export enum ESessionType {
  CHAT = 'chat',
  CALL = 'call',
  HISTORY = 'history',
}
